






















import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';
import {
  FilesApi,
  UnitFacility,
  UnitsApi,
  DocumentRequest,
  Unit,
  Document,
} from '@compassdigital/foodworks.ts.sdk';
import { cloneDeep } from 'lodash';
import StandardCard from '@/components/Card/StandardCard/index.vue';
import FacilityDetail from '@/components/Form/Unit/FacilityDetail/index.vue';
import AppModule from '@/store/modules/app';
import UnitsUtil from '@/util/UnitUtil';
import ToastModule from '@/store/modules/toast';

@Component({
  components: {
    StandardCard,
    FacilityDetail,
  },
})
export default class FacilityTab extends Vue {
  @Prop({}) unitID!: string;

  public unitFacilityData: any = {};

  public facilityUnitOG: any = {};

  public isObject: any = '';

  public loading: boolean = false;

  public docImages: Document[] = [];

  public imageItems: any = [];

  public mounted() {
    this.getScheduleUnits();
  }

  public async getScheduleUnits() {
    try {
      const api = new UnitsApi(AppModule.apiConfig);
      const fetchedUnit = await api.getUnitById(this.unitID);
      const { facility } = fetchedUnit.data;
      this.unitFacilityData = facility;
      if (facility) {
        this.getFilesImage(facility as any);
        this.facilityUnitOG = cloneDeep(facility);
      }
    } catch (err) {
      const { error } = err.response.data;
      ToastModule.setToast({
        message: error.message,
        timeout: 5000,
      });
    }
  }

  public async getFilesImage(facility: UnitFacility) {
    const imageDoc = !facility.unitPictures
      || facility.unitPictures.map(async (id: string) => {
        try {
          const api = new FilesApi(AppModule.apiConfig);
          const fileResponse = await api.getFile(id);
          const { data } = fileResponse;
          if (data) {
            const { documents } = data as any;
            return documents;
          }
        } catch (err) {
          const { error } = err.response.data;
          ToastModule.setToast({
            message: error.message,
            timeout: 5000,
          });
        }
        return '';
      });

    this.loading = true;
    Promise.all(imageDoc as any).then((images) => {
      this.loading = false;
      this.docImages = images as Array<DocumentRequest>;
      this.imageItems = UnitsUtil.formatImages(this.docImages as any);
    });
  }
}
